import { wishlists as wishlistMock } from '../../__mocks__/wishlist';
import { wishlist } from '../../types';
import bossApi from '../../utils/fetch-api';

const DEFAULT_OPTIONS = { m2m: false };
const MOCK_ACCOUNT_API = process.env.MOCK_ACCOUNT_API === 'true';
const HEADERS = {
  'Content-Type': 'application/json',
};

/**
 * Fetch all wishlists for an account
 */
export const getAllWishlists = (accountId: string, locale: string) => {
  if (MOCK_ACCOUNT_API) {
    return Promise.resolve(wishlistMock as unknown as wishlist.Wishlists);
  }
  return bossApi<wishlist.Wishlists>(`/wishlist/v2/wishlists?accountId=${accountId}`, {
    ...DEFAULT_OPTIONS,
    locale,
  });
};

/**
 * Create a new wishlist
 */

export const createWishlist = ({ wishlist, locale }: { wishlist: wishlist.Wishlist; locale: string }) => {
  return bossApi<wishlist.Wishlist>(`/wishlist/v2/wishlists`, {
    ...DEFAULT_OPTIONS,
    method: 'POST',
    headers: HEADERS,
    body: wishlist as unknown as Record<string, unknown>,
    locale,
  });
};

/**
 *  Delete a wishlist
 */

export const deleteWishlist = ({ wishlistId, locale }: { wishlistId: string; locale: string }) => {
  return bossApi<wishlist.Wishlists>(`/wishlist/v2/wishlists/${wishlistId}`, {
    ...DEFAULT_OPTIONS,
    method: 'DELETE',
    headers: HEADERS,
    locale,
  });
};

/**
 * Update a new wishlist
 */

export const updateWishlist = ({ wishlist, locale }: { wishlist: wishlist.Wishlist; locale: string }) => {
  return bossApi<wishlist.Wishlists>(`/wishlist/v2/wishlists/${wishlist.id}`, {
    ...DEFAULT_OPTIONS,
    method: 'PUT',
    headers: HEADERS,
    body: wishlist as unknown as Record<string, unknown>,
    locale,
  });
};

/**
 *  Create a wishlistLine
 */

export const createWishlistLine = ({
  wishlistLine,
  wishlistId,
  locale,
}: {
  wishlistLine: wishlist.WishlistLine;
  wishlistId: string;
  locale: string;
}) => {
  return bossApi<wishlist.WishlistLine>(`/wishlist/v2/wishlists/${wishlistId}/lines`, {
    ...DEFAULT_OPTIONS,
    method: 'POST',
    headers: HEADERS,
    body: wishlistLine as unknown as Record<string, unknown>,
    locale,
  });
};

/**
 *  Delete a wishlistLine
 */

export const deleteWishlistLine = ({
  wishlistLineId,
  wishlistId,
  locale,
}: {
  wishlistLineId: string;
  wishlistId: string;
  locale: string;
}) => {
  return bossApi<wishlist.Wishlists>(`/wishlist/v2/wishlists/${wishlistId}/lines/${wishlistLineId}`, {
    ...DEFAULT_OPTIONS,
    method: 'DELETE',
    headers: HEADERS,
    locale,
  });
};

/**
 *  Update a wishlistLine
 */

export const updateWishlistLine = ({
  wishlistLine,
  wishlistId,
  locale,
}: {
  wishlistLine: wishlist.WishlistLine;
  wishlistId: string;
  locale: string;
}) => {
  return bossApi<wishlist.WishlistLine>(`/wishlist/v2/wishlists/${wishlistId}/lines/${wishlistLine.id}`, {
    ...DEFAULT_OPTIONS,
    method: 'PUT',
    headers: HEADERS,
    body: wishlistLine as unknown as Record<string, unknown>,
    locale,
  });
};
